import type { Icon } from "@tabler/icons-react";
import {
  IconBook,
  IconBrain,
  IconChartBar,
  IconCreditCard,
  IconDashboard,
  IconKey,
  IconUser,
} from "@tabler/icons-react";

export type SidebarNavItem = {
  title: string;
  url: string;
  icon: Icon;
};

/** Main — Dashboard + Models */
export const appSidebarNavMain: SidebarNavItem[] = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: IconDashboard,
  },
  {
    title: "Models",
    url: "/models",
    icon: IconBrain,
  },
];

/** Developer — API keys + Usage (keep in sync with services/frontend/shared/navigation/app-sidebar-nav.ts) */
export const appSidebarNavDeveloper: SidebarNavItem[] = [
  {
    title: "API keys",
    url: "/keys",
    icon: IconKey,
  },
  {
    title: "Usage",
    url: "/usage",
    icon: IconChartBar,
  },
];

/** Account — Account + Billing */
export const appSidebarNavAccount: SidebarNavItem[] = [
  {
    title: "Account",
    url: "/manage/account",
    icon: IconUser,
  },
  {
    title: "Billing",
    url: "/manage/billing",
    icon: IconCreditCard,
  },
];

/** Footer — sits above the account menu, below the divider */
export const appSidebarNavFooter: SidebarNavItem[] = [
  {
    title: "Docs",
    url: "/docs/",
    icon: IconBook,
  },
];

/** Flat list for user menu dropdown (same order as sidebar). */
export const appSidebarNavAll: SidebarNavItem[] = [
  ...appSidebarNavMain,
  ...appSidebarNavDeveloper,
  ...appSidebarNavAccount,
  ...appSidebarNavFooter,
];
